export interface Toast {
  id: string
  title?: string
  text?: string
  type?: 'info' | 'error'
  dismissible?: boolean
}

export function useToast () {
  const toasts = useState<Toast[]>('toasts', () => [])

  const removeToast = (id: string) => {
    toasts.value = toasts.value.filter(toast => toast.id !== id)
  }

  const addToast = (props: Omit<Toast, 'id'>) => {
    const id = Math.random().toString()
    toasts.value = [...toasts.value, { dismissible: true, type: 'info', ...props, id }]
    setTimeout(() => removeToast(id), 3000)
  }

  return { toasts, addToast, removeToast }
}
